"use strict";

/**
 * @type Controller
 * @name advancedSearch_ctrl
 * @packageName advancedSearch_ctrl.js
 *
 */
class advancedSearch_ctrl {
    constructor($scope, $mdDialog, $http, $state, $location, $sce, searchText, $mdMenu, moment) {
        this.$scope = $scope;
        this.$mdDialog = $mdDialog;
        this.$http = $http;
        this.$state = $state;
        this.$location = $location;
        this.$sce = $sce;
        this.$mdMenu = $mdMenu;

        this.searchText = searchText;
        this.advancedMenu = false;
        this.options = {
            model: {},
            model_type: {},
            page: 1
        };
        this.total = 0;
        this.maxPerPage = 15;
        this.models = [];
        this.model_types = [];
        this.itemNames = [];
        this.modelnames = {
            playout: 'item',
            spoken: 'item',
        };
        this.results = {};
        this.suggests = {};
        this.routes = {
            campaigns: 'campaign.update',
            broadcasts: 'epg.update',
            contacts: 'contacts.update',
            //item
            presenters: 'presenters.update',
            programs: 'programs.update',
            users: 'user.update',
        };

        $scope.asCtrl = this;

        window.searching = true;
        $scope.$on('$destroy', () => {
            window.searching = false;
        });

        $scope.activeObject = {};
        $scope.goTo = (object) => {
            let route = this.routes[object._source._rmtype];
            let sourceId = object._source.id;
            switch(object._source._rmtype) {
                case 'items':
                    switch(object._source.kind) {
                        case 0:
                        case 'block':
                            this.$state.go('rundown.edit', {
                                itemId: sourceId,
                                blockId: object._source.block_id,
                                program: object._source.program_id,
                                broadcast: object._source.broadcast_id,
                                type: 'block',
                            }, {reload: true});
                            break;
                        case 1:
                            this.$state.go('rundown.drafts.edit', {
                                itemId: sourceId,
                                program: object._source.program_id,
                                broadcast: object._source.broadcast_id,
                                type: 'program',
                            }, {reload: true});
                            break;
                        case 2:
                            this.$state.go('rundown.drafts.edit', {
                                itemId: sourceId,
                                program: object._source.program_id,
                                broadcast: object._source.broadcast_id,
                                type: 'station'
                            }, {reload: true});
                            break;
                        case 3:
                            this.$state.go('rundown.drafts.edit', {
                                itemId: sourceId,
                                program: object._source.program_id,
                                broadcast: object._source.broadcast_id,
                                type: 'personal'
                            }, {reload: true});
                            break;
                    }
                    break;
                case 'broadcasts':
                    this.$state.go(route, {broadcastId: sourceId}, {reload: true});
                    break;
                case 'programs':
                    this.$state.go(route, {programId: sourceId}, {reload: true});
                    break;
                case 'contacts':
                    this.$state.go(route, {contactId: sourceId}, {reload: true});
                    break;
                default:
                    this.$state.go(route, {id: sourceId}, {reload: true});
                    break;
            }

            this.$mdDialog.hide();
            $scope.activeObject = {};
        };

        $scope.pagination = {
            current: 1
        };

        this.fetch();

    };

    fetch() {
        this.$http.get('/search-options/language').then((response) => {
            this.models = response.data.modelNames;
            this.itemNames = response.data.itemNames;
        });
        this.updateModelTypes();
    }

    updateModelTypes() {
        if(this.options.model.value !== undefined) {
            this.options.model_type = {};
        }
        let search = this.modelnames[this.options.model.value];
        let type = search !== undefined ? search : this.options.model.value;
        this.$http.get('/modeltypes/' + type).then((response) => {
            let data = response.data[type];
            this.model_types = (data !== undefined && data.length > 1 ? data : []);
        });
    }

    cancelButton() {
        this.$mdDialog.cancel();
    }

    toggleAdvancedMenu() {
        this.advancedMenu = this.advancedMenu != true;
    }

    setActiveModel(model) {
        this.options.model.name = this.models[model];
        this.options.model.value = model;
        this.updateModelTypes();
        this.search();
        this.$scope.pagination = {
            current: 1
        };
    }

    setActiveModelType(modelType) {
        if(modelType == null) {
            this.options.model_type = {};
        } else {
            this.options.model_type.name = modelType['name'];
            this.options.model_type.id = modelType['id'];
        }
        this.search();
    }

    search(page = 0) {
        let query = this.searchText;
        if(!query) {
            this.results = {};
            return;
        }
        this.options.page = page == 0 ? 1 : page;
        this.$http.post('/search/' + encodeURIComponent(query), this.options).then((response) => {
            this.results = response.data;
            this.total = this.results.totals.pagination.value;
            if(this.resultNotEmpty() && page == 0) {
                this.setActive(this.firstItem());
            }
        });
    }

    suggest() {
        clearTimeout(this.waitSearch);
        let query = this.searchText;
        if(!query) {
            this.suggests = {};
            return;
        }
        let queryArr = query.split(' ');
        let queryLast = queryArr[queryArr.length - 1];
        this.$http.post('/suggest/' + encodeURIComponent(queryLast), this.options).then((response) => {

            this.suggests = response.data.map((suggest) => {
                return suggest.text; //console.log(suggest);
            });
        });
        this.waitSearch = setTimeout(() => {
            this.search();
        }, 1000);
    }

    resultNotEmpty() {
        let hasValue = 0;
        angular.forEach(this.results, (value, key) => {
            if(key != 'totals' && value.length > 0) {
                hasValue++;
            }
        });
        return hasValue > 0;
    }

    isActive(object) {
        return object._type == this.$scope.activeObject._type && object._id == this.$scope.activeObject._id;
    }

    setActive(object) {
        this.$scope.activeObject = object;
        this.$scope.aSource = object._source;
        this.$scope.aHighlight = object.highlight;
    }

    firstItem() {
        let item;
        let found = false;
        angular.forEach(this.results, (value, key) => {
            if(key != 'totals' && value.length > 0 && !found) {
                item = value[0];
                found = true;
            }
        });
        return item;
    }

    sanitizeHtml(text) {
        return this.$sce.trustAsHtml(text);
    }

    getEndItem(start, duration) {
        let startDate = new Date(start);
        return startDate.setSeconds(startDate.getSeconds() + duration)
    }

    checkPart(part, wholeText) {
        //set new text
        let newText = part;
        //remove em tags for checking
        part.replace('<em>', '').replace('</em>', '');
        //get first 10 chars of both
        let startText = wholeText.substring(0, 10);
        let startPart = part.substring(0, 10);
        // get last 10 chars of both
        let endText = wholeText.substring(wholeText.length - 11, wholeText.length - 1);
        let endPart = part.substring(part.length - 11, part.length - 1);

        //check if part is at start and/or end
        if(startText != startPart) {
            newText = '...' + newText;
        }
        if(endText != endPart) {
            newText = newText + '...';
        }
        return newText;
    }

    getItemDate(item, duration = false) {
        let drafts = '';
        switch(item.kind) {
            case 0:
            case 'block':
                let time = moment(item.start);
                if(duration) {
                    return '(' + time.format('LTS') + ' - ' + moment(this.getEndItem(time, duration)).format('LTS') + ')';
                } else {
                    return time.format('L');
                }
                break;
            case 1:
                drafts = this.itemNames['program'];
                break;
            case 2:
                drafts = this.itemNames['station'];
                break;
            case 3:
                drafts = this.itemNames['personal'];
                break;
        }
        return !duration ? drafts : null;
    }

    isDraft(kind) {
        return kind != 0 && kind != 'block';
    }

}

/*
 * Inject dependicies
 */
advancedSearch_ctrl.$inject = ['$scope', '$mdDialog', '$http', '$state', '$location', '$sce', 'searchText', '$mdMenu', 'moment'];

/*
 * Browsify connection: execute controller
 */
module.exports = advancedSearch_ctrl;
